import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class ScoreProxy extends ProxyBase {
  getCreditRiskScore(params) {
    return this.get('CreditRiskScore', params)
  }
  getPerformanceScore(params) {
    return this.get('PerformanceScore', params)
  }
}

export default new ScoreProxy('IndustryAnalysis/')
